import { SUBTYPE_OPTS, time, getSuper, bindPrototype, assignPrivateSymbol, setSymbols, getSymbols, iu, initAbstract, construct, $combine, subtype, implementEngineer, $skip, makeClassSymbol } from '@type.engineering/type-engineer'
import '../'
import '../typedefs/private'
import BuildingBlock, { control } from '../../src/lib/BuildingBlock'
import proxifyState from '../../src/lib/proxify-state'

/**
 * @abstract
 * @extends {guest.maurice.ui.Collapsable}
 */
class _AbstractCollapsable {
  constructor() {
    construct(this)
  }
  /** @nocollapse */
  static control(el, opts) {
    const AllSymbols = CollapsableSymbols
    /** @suppress {checkTypes} */
    const res = control(this, el, opts, AllSymbols)
    return /** @type {!guest.maurice.ui.Collapsable} */ (res)
  }
}
/**
 * The colllapsable interface allows to show and hide elements on a page via
 * collapse animation.
 * @extends {guest.maurice.ui.Collapsable} ‎
 * @implements {guest.maurice.ui.ICollapsable} ‎
 */
export class AbstractCollapsable extends _AbstractCollapsable {

}
initAbstract(_AbstractCollapsable, 'ICollapsable', /** @this {AbstractCollapsable} */ function () {
  const { superStateful: { setState, initialState } } = this
  const state = {
    collapsed: false,
    collapsing: false,
    uncollapsing: false,
    ...initialState,
  }
  proxifyState(state)
  setState(state)
})
/** @constructor @extends {_AbstractCollapsable} @suppress {checkTypes} */ function __AbstractCollapsable() {}
__AbstractCollapsable.prototype = /** @type {!_AbstractCollapsable} */ ({
  get asICollapsable() {
    return /** @type {!guest.maurice.ui.BoundICollapsable} */ (this)
  },
  get superICollapsable() {
    return /** @type {!guest.maurice.ui.BoundICollapsable} */ (bindPrototype(_AbstractCollapsable, this))
  },
  get superCollapsable() {
    return /** @type {!guest.maurice.ui.BoundCollapsable} */ (bindPrototype(_AbstractCollapsable, this))
  },
})
export const CollapsableSymbols = {
  __: makeClassSymbol(AbstractCollapsable, '__'),
}

/** @type {guest.maurice.ui.getCollapsableSymbols} */
export const getCollapsableSymbols = (instance) => {
  return /** @type {!guest.maurice.ui.ICollapsableSymbolsOut} */ (getSymbols(instance, CollapsableSymbols))
}
/** @type {guest.maurice.ui.setCollapsableSymbols} */
export const setCollapsableSymbols = (instance, symbols) => {
  setSymbols(instance, symbols, CollapsableSymbols)
}

AbstractCollapsable.__implement(__AbstractCollapsable, BuildingBlock)

/**
 * @abstract
 * @extends {guest.maurice.ui.Concealed}
 */
class _AbstractConcealed {
  constructor() {
    construct(this)
  }
  /** @nocollapse */
  static control(el, opts) {
    const AllSymbols = ConcealedSymbols
    /** @suppress {checkTypes} */
    const res = control(this, el, opts, AllSymbols)
    return /** @type {!guest.maurice.ui.Concealed} */ (res)
  }
}
/**
 * The concealed interface allows to control whether blocks and bricks are
 * currently hidden in the layout.
 * @extends {guest.maurice.ui.Concealed} ‎
 * @implements {guest.maurice.ui.IConcealed} ‎
 */
export class AbstractConcealed extends _AbstractConcealed {

}
initAbstract(_AbstractConcealed, 'IConcealed', /** @this {AbstractConcealed} */ function () {
  const { superStateful: { setState, initialState } } = this
  const state = {
    concealed: false,
    ...initialState,
  }
  proxifyState(state)
  setState(state)
})
/** @constructor @extends {_AbstractConcealed} @suppress {checkTypes} */ function __AbstractConcealed() {}
__AbstractConcealed.prototype = /** @type {!_AbstractConcealed} */ ({
  get asIConcealed() {
    return /** @type {!guest.maurice.ui.BoundIConcealed} */ (this)
  },
  get superIConcealed() {
    return /** @type {!guest.maurice.ui.BoundIConcealed} */ (bindPrototype(_AbstractConcealed, this))
  },
  get superConcealed() {
    return /** @type {!guest.maurice.ui.BoundConcealed} */ (bindPrototype(_AbstractConcealed, this))
  },
})
export const ConcealedSymbols = {
  __: makeClassSymbol(AbstractConcealed, '__'),
}

/** @type {guest.maurice.ui.getConcealedSymbols} */
export const getConcealedSymbols = (instance) => {
  return /** @type {!guest.maurice.ui.IConcealedSymbolsOut} */ (getSymbols(instance, ConcealedSymbols))
}
/** @type {guest.maurice.ui.setConcealedSymbols} */
export const setConcealedSymbols = (instance, symbols) => {
  setSymbols(instance, symbols, ConcealedSymbols)
}

AbstractConcealed.__implement(__AbstractConcealed, BuildingBlock)